import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import '../styles/header/Header.min.css';
import logo from "../images/header-logo.svg";

const Header = () => {
  const [expanded, setExpanded] = useState(false);

  // Close mobile menu when a link is clicked
  const closeMenu = () => setExpanded(false);

  return (
    <Navbar expand="lg" expanded={expanded} className='custom-navbar d-flex align-items-center justify-content-center py-1'>
      <Container className="px-5 mx-0">
        <Navbar.Brand as={Link} to="/" className='me-0' onClick={closeMenu}>
          <img src={logo} alt="Y4C logo" className="main-logo" />
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="navbarItems"
          onClick={() => setExpanded(expanded ? false : true)}
          className='navbar-toggler'
        />
        <Navbar.Collapse id="navbarItems">
          <div className='d-flex w-100 justify-content-end'>
            <Nav className="">
              <Nav.Link 
                as={NavLink} 
                to="/sobre-nos" 
                className='header-link py-0'
                onClick={closeMenu}
              >
                Sobre nós
              </Nav.Link>
              <Nav.Link 
                as={NavLink} 
                to="/projetos" 
                className='header-link py-0'
                onClick={closeMenu}
              >
                Projetos
              </Nav.Link>
              <Nav.Link 
                as={NavLink} 
                to="/equipa" 
                className='header-link py-0'
                onClick={closeMenu}
              >
                Equipa
              </Nav.Link>
              <Nav.Link 
                as={NavLink} 
                to="/contactos" 
                className='header-link py-0'
                onClick={closeMenu}
              >
                Contactos
              </Nav.Link>
              <Nav.Link 
                as={NavLink} 
                to="/como-ajudar" 
                className='header-link py-0'
                onClick={closeMenu}
              >
                Como Ajudar
              </Nav.Link>
            </Nav>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;